import React, { useEffect, useState } from "react";
import { Row, Col, Input } from "antd";
import TinyEditor from "../../../components/atoms/formFields/tinyEditor";
import media from "../../../media";
import { SaveProduct } from "../../../store/thunks/productThunk";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select/base";
import SelectOption from "../../../components/atoms/formFields/selectOption";
import { GetAllBrands } from "../../../store/thunks/brandThunk";
import BottomRightButton from "../../../components/atoms/formFields/buttons/bottomRightButton";
import { ContentInputField } from "../../../components/atoms/formFields/inputField/contentInputField";
import { Navigate } from "react-router-dom";
import { resetProduct } from "../../../store/slices/productSlice";

const ProductForm = () => {
    const dispatch = useDispatch();
    const ip = useSelector((state) => state?.ip);
    const { data: brands } = useSelector(state => state?.allBrands);
    const { data: saveProductData } = useSelector(state => state?.saveProductData);
    const [dropDown, setDropDown] = useState("");
    const [disable, setDisable] = useState();
    const [formState, setFormState] = useState({
        images: [],
    });
    const [errors, setErrors] = useState();
    console.log("errors", errors);
    useEffect(() => {
        dispatch(GetAllBrands());
    }, []);
    const getOptions = (data, labelKey = 'name.en', valueKey = 'key') =>
        data?.map(item => ({
            label: labelKey.split('.').reduce((o, k) => o?.[k], item),
            value: item?.[valueKey]
        })) || [];

    const handleInputChange = (field, value) => {
        setFormState({ ...formState, [field]: value });
        setErrors({ ...errors, [field]: value ? "" : `${field === "name" ? "Product Name" : "Brand Name"} is Mandatory` });
    };

    const handleFileChange = (field, file) => {
        setFormState({ ...formState, [field]: file });
        setErrors({ ...errors, [field]: file ? "" : `${field} is Mandatory` });
    };

    const handleImageChange = (index, file) => {
        const updatedImages = formState?.images?.map((img, i) => (i === index ? file : img));
        setFormState({ ...formState, images: updatedImages });
    };

    const isValid = () => {
        const { name, description, brandName, brandLogo } = formState;
        const logoRequired = dropDown === "create" && !brandLogo;
        document.querySelector(".tox-tinymce").classList.toggle("invalid", !description);
        const validationErrors = {
            name: name ? "" : "Product Name is Mandatory",
            description: description ? "" : "About is Mandatory",
            brandName: brandName ? "" : "Brand Name is Mandatory",
            brandLogo: logoRequired ? "Brand Logo is Mandatory" : ""
        };
        setErrors(validationErrors);
        return !(validationErrors.name || validationErrors.description || validationErrors.brandName || validationErrors.brandLogo);
    };

    if (saveProductData) {
        dispatch(resetProduct());
        return <Navigate to="/trackApprovalRequests" replace />;
    }

    return (
        <div className="m-0" id="second_level">
            <div className="all_product_area">
                <div id="ant_inputs">
                    <form>
                        <p className="font-size-sm font-weight-bolder mb-9">
                            <span style={{ color: "Red" }}>NOTE: </span>
                            After submitting this form, Apni Kheti team will contact you shortly for further details of the product. Once added to our catalog, you'll be notified.
                        </p>

                        <label className="font-weight-bolder font-size-lg mb-3 d-block h5">Product Details</label>
                        <Row gutter={[12, 12]}>
                            <Col sm={24} lg={6}>
                                <label className="font-weight-bolder font-size-sm">Product Name<span className="text-danger">*</span></label>
                                <ContentInputField
                                    placeholder="Product Name"
                                    filter={true}
                                    value={formState?.name}
                                    errors={errors?.name}
                                    onChange={(e) => handleInputChange("name", e.target.value)}
                                />
                            </Col>
                        </Row>

                        <div className="w-100 separator separator-solid my-5 d-block" />

                        <Row gutter={[12, 12]} className="position-relative zindex-2">
                            <Col sm={24} lg={12}>
                                <label className="font-weight-bolder font-size-sm">Select Brand Name<span className="text-danger">*</span></label>
                                <SelectOption
                                    filter={true}
                                    placeholder="Select Brand Name"
                                    isClearable
                                    options={[
                                        { label: "Create New Brand", value: "create" }, // 👈 first option
                                        ...getOptions(brands),
                                    ]}
                                    error={errors?.brandName}
                                    onChange={(val) => {
                                        setDropDown(val.value);
                                        if (val.value !== "create") {
                                            setFormState({ ...formState, brandName: val.label, brandImageId: val.value.brandLogo });
                                            setErrors({ ...errors, brandName: val.label ? "" : "Brand is Mandatory" });
                                        }
                                        else{
                                            setFormState({ ...formState, brandName: "", brandLogo: "" });
                                        }
                                    }}
                                />

                                {dropDown === "create" && (
                                    <div className="brand-logo my-6">
                                        <label className="font-weight-bolder font-size-lg mb-6 d-block h5">Brand Name & Logo<span className="text-danger">*</span></label>
                                        <div className="align-items-center d-block d-lg-flex max-w-550px mb-6">
                                            <div className="mb-10 mb-lg-0 mr-lg-10 user_image">
                                                <div className={`image-input image-input-outline`}>
                                                    <div className={errors?.brandLogo ? "image-input-wrapper invalid" : "image-input-wrapper"}>
                                                        <img src={formState?.brandLogo ? URL.createObjectURL(formState.brandLogo) : media.Default} alt="img" />
                                                    </div>

                                                    <label className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="change" data-toggle="tooltip" title="" data-original-title="Change avatar"><i class="fa fa-pen icon-sm text-muted"></i>
                                                        <input
                                                            type="file"
                                                            accept=".png, .jpg, .jpeg"
                                                            onChange={(e) => handleFileChange("brandLogo", e.target.files[0])}
                                                        />
                                                        <input type="hidden" name="profile_avatar_remove" />
                                                    </label>

                                                    <span className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="cancel" data-toggle="tooltip" title="Cancel avatar">
                                                        <i className="ki ki-bold-close icon-xs text-muted"></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="brand-info">
                                                <Input
                                                    placeholder="Your Brand Name"
                                                    value={formState?.brandName}
                                                    className={errors?.brandName ? "invalid" : ""}
                                                    onChange={(e) => handleInputChange("brandName", e.target.value)}
                                                />
                                                <p className="d-block font-size-sm font-weight-bold mt-2">
                                                    New Brand and Product will be verified in 24 hours. Only edit option will be available until verification.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Col>
                        </Row>

                        <div className="w-100 separator separator-solid my-5 d-block" />

                        <label className="font-weight-bolder font-size-lg mb-3 d-block h6">About this item<span className="text-danger">*</span></label>
                        <Row gutter={[48, 12]}>
                            <Col sm={24} lg={12}>
                                <TinyEditor
                                    className={errors?.description ? "invalid" : ""}
                                    value={formState?.description || ""}
                                    func={(content) => {
                                        setFormState({ ...formState, description: content });
                                        setErrors({ ...errors, description: content ? "" : "About is Mandatory" });
                                        document.querySelector(".tox-tinymce").classList.toggle("invalid", !content);
                                    }}
                                />
                                <small className="text-danger text-capitalize">{errors?.description}</small>
                            </Col>
                        </Row>

                        <div className="w-100 separator separator-solid my-5 d-block" />
                        <div className="d-flex align-items-center justify-content-left">
                            <label className="font-weight-bolder font-size-lg my-3 d-block h5 mr-5">Upload Product Images</label>
                            <i className="ki ki-plus upload_plus" onClick={() => setFormState({ ...formState, images: [...formState.images, {}] })}></i>
                        </div>
                        <div className="media_area">
                            {formState?.images?.map((img, i) => (
                                <div className="my-4 repeat_div" key={i}>
                                    <div className="align-items-center d-flex justify-content-between mb-2">
                                        {formState.images.length > 1 && (
                                            <i className="ki ki-close upload_close" onClick={() => setFormState({ ...formState, images: formState.images.filter((_, idx) => idx !== i) })}></i>
                                        )}
                                    </div>
                                    <div className="d-flex">
                                        <div className="mx-2">
                                            <label className="card-label font-weight-bolder text-dark d-block">Image</label>
                                            <div className="d-flex file-upload-wrappers border">
                                                <input
                                                    id={`${i}image`}
                                                    type="file"
                                                    accept=".jpg, .jpeg, .png, .svg, .ogg"
                                                    className="p-2 image_inp"
                                                    onChange={(e) => handleImageChange(i, e.target.files[0])}
                                                />
                                                <label className="btn btn-warning font-weight-bolder m-0" htmlFor={`${i}image`}>
                                                    Upload
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="w-100 separator separator-solid my-5 d-block" />

                        <div className="my-5 text-lg-right text-center">
                            <BottomRightButton
                                type="submit"
                                className={disable ? "disabled" : ""}
                                disabled={disable}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (isValid()) {
                                        dispatch(SaveProduct({ payload: { ip: ip, ...formState } }))
                                        setDisable(true);
                                    }
                                }}

                                name="Submit"
                            />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ProductForm;
